import styled from 'styled-components';

export const Wrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
`;

export const IconWrapper = styled.i`
    margin-right: 6px;

    svg {
        width: 20px;
        height: 20px;
    }
`;
